import React from "react"
import { Helmet } from "react-helmet"

const Seo = ({ lang, title, description, image, url, robotsIndex, robotsFollow }) => {

    const seo = {
        title: title,
        description: description,
        image: image,
        url: url,
        robotsIndex: robotsIndex,
        robotsFollow: robotsFollow,
        lang: lang,
    };

    return (
        <Helmet>
            <html lang={seo.lang} />
            <meta name="robots" content={`${seo.robotsIndex},${seo.robotsFollow}`}/>
            {seo.title &&  <title>{seo.title}</title>}
            {seo.url &&  <link rel="canonical" href={seo.url}/>}
            {seo.description && <meta name="description" content={seo.description} />}
            {seo.image && <meta name="image" content={seo.image} />}
            {seo.url &&  <meta property="og:url" content={seo.url}/>}
            {seo.title &&  <meta property="og:title" content={seo.title} />}
            {seo.description &&  <meta property="og:description" content={seo.description} />}
            {seo.image && <meta property="og:image" content={seo.image} />}
        </Helmet>
    )
};

export default Seo
